import classNames from 'classnames';
import * as React from 'react';
import { useState, useRef } from 'react';
import { t } from '../../localization.js';
import Input from '../Input/Input.js';
import styles from './Autocomplete.module.scss.js';

var Autocomplete = function (props) {
    var className = props.className, value = props.value, width = props.width, maxLength = props.maxLength, _a = props.minLength, minLength = _a === void 0 ? 2 : _a, placeholder = props.placeholder, renderItem = props.renderItem, autocomplete = props.autocomplete, suggestionCount = props.suggestionCount, onClear = props.onClear, onChange = props.onChange, onSearch = props.onSearch, onSelect = props.onSelect;
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    var _c = useState(null), selectedIndex = _c[0], setSelectedIndex = _c[1];
    var inputRef = useRef(null);
    var menuRef = useRef(null);
    var blurInput = function () {
        if (inputRef && inputRef.current) {
            inputRef.current.blur();
        }
    };
    var onBlur = function () {
        setIsVisible(false);
        setSelectedIndex(null);
    };
    var onFocus = function () {
        setIsVisible(true);
        menuRef.current && menuRef.current.focus();
    };
    var onKeyPress = function (e) {
        switch (e.nativeEvent.keyCode) {
            case 27: {
                onEsc();
                break;
            }
            case 13: {
                onEnter();
                break;
            }
            case 38: {
                onArrowUp();
                break;
            }
            case 40: {
                onArrowDown();
                break;
            }
            default: {
                return;
            }
        }
    };
    var onEsc = function () {
        onBlur();
        blurInput();
    };
    var onEnter = function () {
        onBlur();
        blurInput();
        if (selectedIndex !== null && selectedIndex !== undefined) {
            onSelectInto(selectedIndex);
        }
        else {
            onSearch(value);
        }
    };
    var onArrowDown = function () {
        var count = suggestionCount ? suggestionCount : 5;
        var newIndex = 0;
        if (selectedIndex) {
            newIndex = selectedIndex + 1;
        }
        if (selectedIndex === null) {
            newIndex = 0;
        }
        if (newIndex === count) {
            newIndex = 0;
        }
        setSelectedIndex(newIndex);
    };
    var onArrowUp = function () {
        var count = suggestionCount ? suggestionCount : 5;
        var newIndex = 0;
        if (selectedIndex) {
            newIndex = selectedIndex - 1;
        }
        if (newIndex < 0) {
            newIndex = count - 1;
        }
        setSelectedIndex(newIndex);
    };
    var onSelectInto = function (index) {
        if (autocomplete && autocomplete.length && autocomplete[index] && onSelect) {
            onSelect(autocomplete[index]);
        }
    };
    var onTextInput = function (e) {
        onChange(e.target.value);
        if (e.target.value.length === 0) {
            onClear();
        }
    };
    var onItemClick = function (index) { return function () {
        onBlur();
        blurInput();
        onSelectInto(index);
    }; };
    var overlayClick = function () {
        onBlur();
        blurInput();
    };
    var clear = function () {
        onBlur();
        blurInput();
        if (onClear) {
            onClear();
        }
    };
    var renderAutocomplete = function () {
        var autocompleteItems = autocomplete && autocomplete.length > 0 ? autocomplete.slice(0, suggestionCount ? suggestionCount : 5) : [];
        if (isVisible && value && value.length < minLength && value.length > 0) {
            return (React.createElement("div", { className: styles.autocomplete },
                React.createElement("div", { className: styles.overlay, onClick: overlayClick }),
                React.createElement("div", { className: styles.message }, t('Введите хотя бы 2 символа для поиска клана.'))));
        }
        else if (isVisible && autocompleteItems && autocompleteItems.length > 0) {
            return (React.createElement("div", { className: styles.autocomplete, ref: menuRef },
                React.createElement("div", { className: styles.overlay, onClick: overlayClick }),
                autocompleteItems.map(function (item, index) {
                    var isSelected = index === selectedIndex;
                    return (React.createElement("div", { key: "autocomplete-item-" + index, className: styles.item + " " + (isSelected ? styles.selected : ''), onClick: onItemClick(index) }, renderItem ? renderItem(item) : "" + item));
                })));
        }
        return null;
    };
    var isEnterVisible = value && value.length > 1;
    return (React.createElement("div", { className: classNames(styles.wrapper, className) },
        React.createElement(Input, { ref: function (r) {
                if (r) {
                    inputRef = r._input;
                }
            }, noimesupport: true, value: value || '', width: width, maxLength: maxLength, onChange: onTextInput, placeholder: placeholder, onFocus: onFocus, onKeyDownCapture: onKeyPress, isFocusOn: isVisible, t: t }),
        renderAutocomplete(),
        isEnterVisible && React.createElement("div", { className: styles.enter, onClick: onEnter }),
        isEnterVisible && React.createElement("div", { className: styles.clear, onClick: clear })));
};
var Autocomplete$1 = React.memo(Autocomplete);

export { Autocomplete$1 as default };
//# sourceMappingURL=Autocomplete.js.map
